import Vue from 'vue'
import Router from 'vue-router'

const homeView = () => import('pages/homeView');
const imageView = () => import(/* webpackChunkName: "image" */ "pages/imageView");
const subNavView = () => import(/* webpackChunkName: "image" */ "pages/subNavView");
const campaignView = () => import(/* webpackChunkName: "image" */ "pages/campaignView");
const lookBookView = () => import(/* webpackChunkName: "image" */ "pages/lookBookView");
const shootingTidbitsView = () => import(/* webpackChunkName: "image"*/ "pages/shootingTidbitsView");
const newsView = () => import(/* webpackChunkName: "news"*/"pages/newsView");
const brandNewsView = () => import(/* webpackChunkName: "news"*/"pages/brandNewsView");
const starView = () => import(/* webpackChunkName: "news"*/"pages/starView");
const storesOpenView = () => import(/* webpackChunkName: "news"*/"pages/storesOpenView");
const fashionShowView = () => import(/* webpackChunkName: "news"*/"pages/fashionShowView");
const newsDetailsView = () => import("pages/newsDetailsView");
const aboutView = () => import("pages/aboutView");
const storesView = () => import("pages/storesView");
const vipView = () => import("pages/vipView");
const contactView = () => import("pages/contactView");
const careerView = () => import("pages/careerView");


Vue.use(Router)

export default new Router({
  base: '/',
  linkActiveClass: 'active',
  linkExactActiveClass: 'cur-active',
  routes: [
    {
      path: '/',
      redirect: '/home',
      component: homeView,
      children: [
        {
          path: '',
          redirect: "/home"
        },
      ]
    },
    {
      path: '/home',
      name: 'home',
      component: homeView
    },
    {
      path: '/image',
      name: 'image',
      component: imageView,
      redirect: '/image/campaign/:id?',
      children: [
        {
          path: 'subNav',
          name: 'subNav',
          component: subNavView
        },
        {
          path: 'campaign',
          name: 'campaign',
          component: campaignView
        },
        {
          path: 'lookBook',
          name: 'lookBook',
          component: lookBookView
        },
        {
          path: 'shootingTidbits',
          name: 'shootingTidbits',
          component: shootingTidbitsView
        },
      ]
    },
    {
      path: '/news',
      name: 'news',
      component: newsView,
      redirect: '/news/brandNews',
      children: [
        {
          path: 'brandNews',
          name: 'brandNews',
          component: brandNewsView
        },
        {
          path: 'fashionShow',
          name: 'fashionShow',
          component: fashionShowView
        },
        {
          path: 'star',
          name: 'star',
          component: starView
        },
        {
          path: 'storesOpen',
          name: 'storesOpen',
          component: storesOpenView
        }
      ]
    },
    {
      path: '/newsDetails',
      name: 'newsDetails',
      component: newsDetailsView
    },
    {
      path: '/about',
      name: 'about',
      component: aboutView
    },
    {
      path: '/stores',
      name: 'stores',
      component: storesView
    },
    {
      path: '/vip',
      name: 'vip',
      component: vipView
    },
    {
      path: '/contact',
      name: 'contact',
      component: contactView
    },
    {
      path: '/career',
      name: 'career',
      component: careerView
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js